import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OptionsComponent } from './options/options.component';
import { SearcherComponent } from './searcher/searcher.component';
import { MultiselectorComponent } from './multiselector/multiselector.component';
import { DropdownComponent } from './dropdown/dropdown.component';
import { TooltipComponent, TooltipDirective } from './tooltip/tooltip.component';
import { FormsModule } from '@angular/forms';
import { TagComponent } from './tag/tag.component';
import { CheckboxComponent } from './checkbox/checkbox.component';
import { InputComponent } from './input/input.component';
import { IconsDirective } from '../icons/icons.directive';

@NgModule({
   imports: [
      CommonModule,
      FormsModule
   ],
   declarations: [
      IconsDirective,
      OptionsComponent,
      SearcherComponent,
      MultiselectorComponent,
      DropdownComponent,
      TooltipComponent,
      TooltipDirective,
      TagComponent,
      CheckboxComponent,
      InputComponent,
   ],
   exports: [
      IconsDirective,
      OptionsComponent,
      SearcherComponent,
      MultiselectorComponent,
      DropdownComponent,
      TooltipComponent,
      TooltipDirective,
      TagComponent,
      CheckboxComponent,
      InputComponent,
   ]
})
export class ComponentsModule { }
